__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-18-1787043240-stable-dev/";